import React from "react";
import PatientLoader from "../../../common/PatientLoader";
import moment from "moment";
import RiskPill from "../../../common/RiskPill";
export const InformationBox = ({
  labelText,
  information,
  type = "normal",
  showPill = false,
}) => {
  return (
    <div className="form-group d-flex my-1 px-1" style={{ gap: "10px" }}>
      {type === "strong" && (
        <label>
          <strong>{labelText}</strong>
        </label>
      )}
      {type === "normal" && <label>{labelText}</label>}
      {showPill ? (
        <RiskPill
          styles={{ width: "fit-content", gap: "5px" }}
          type={information}
          show_icon={false}
        />
      ) : (
        <span>{information}</span>
      )}
    </div>
  );
};

const PatientInformation = ({
  singlePatientData,
  loading,
  bhiData,
  bhiLoading,
  isBHIEligible,
}) => {
  return (
    <div className="container-fluid w-100 p-3 my-4">
      {loading || bhiLoading ? (
        <PatientLoader />
      ) : (
        <>
          <div className="container-fluid w-100 row">
            <div className="col-sm-12 col-md-4 col-lg-4">
              <InformationBox
                labelText={"Email:"}
                information={singlePatientData?.email}
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <InformationBox
                labelText={"DOB:"}
                information={singlePatientData?.date_of_birth || "Unavailable"}
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <InformationBox
                labelText={"Rose Enrollment Date:"}
                information={moment(bhiData?.enrollment_date).format(
                  "MM/DD/YYYY"
                )}
              />
            </div>
          </div>
          <div className="container-fluid w-100 row">
            <div className="col-sm-12 col-md-4 col-lg-4">
              <InformationBox
                labelText={"Gender:"}
                information={singlePatientData?.gender || "Unavailable"}
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <InformationBox
                labelText={"BHI Status:"}
                information={isBHIEligible ? "eligible" : "not eligible"}
                showPill
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <InformationBox
                labelText={"BH Diagnosis:"}
                information={bhiData?.diagnosis || "Unavailable"}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PatientInformation;
